import { render } from "./ServiceRequests.vue?vue&type=template&id=04c77cf2&scoped=true"
import script from "./ServiceRequests.vue?vue&type=script&lang=js"
export * from "./ServiceRequests.vue?vue&type=script&lang=js"

import "./ServiceRequests.vue?vue&type=style&index=0&id=04c77cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c77cf2"]])

export default __exports__